<template>

  <div id="file-drop-error" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto uk-margin-auto-vertical">
      <div class="uk-flex uk-flex-center">
        <img class="icon-container"  :src="errorIcon">
      </div>
    <span class="message">{{errorMessage}}</span>
    <div class="uk-flex uk-flex-middle footer">
      <div class="uk-float-left full-width">
        <span class="error-code">{{errorCode}}</span>
      </div>
      <div class="uk-float-right full-width">
        <button class="uk-button cp-primary-button uk-modal-close uk-float-right" type="button">{{$t('general.ok')}}</button>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconUtil from '../../../utils/icon-util'
  import * as misc from '../../../enums/misc'
  import * as errorCode from '../../../enums/error-codes'
  import * as errorMessage from '../../../enums/error-messsages'

  export default {
    name: 'file-drop-error',
    data() {
      return {
        errorIcon: iconUtil.resolve(misc.WARNING_ICON_GREY),
        errorCode: errorCode.CP_400,
        errorMessage: errorMessage.CP_400
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../styles/colours.scss';
  .error-code {
    color: $file-drag-error-code;
    font-size: 16px;
  }

  .icon-container {
    height: 65px;
    width: 65px;
    margin-bottom: 40px;
  }

  .message {
    font-weight: bold;
    font-size: 1.25rem;
    color: #555;
  }

  .uk-button {
    width: 100%;
    height: 44px;
    font-size: 20px;
  }

 .footer {
   margin-top: 20px;
   width: 100%;
 }

  .full-width {
    width: 100%
  }

</style>
